// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"65":"8b122c8d","73":"17971b98","129":"d7649858","265":"9c4ae4ea","428":"7f7d56d9","673":"be0f872d","833":"a14b2b3b","846":"f12dbaf0","956":"b57bfae5","974":"80b1e294"}[chunkId] + ".js";
};